if (!customElements.get('account-login')) {
  class AccountLogin extends HTMLElement {
    constructor() {
      super();
      this.searchParams = new URLSearchParams(window.location.search);
    }

    connectedCallback() {
      const tabs = this.querySelectorAll('[data-target]');
      const forms = this.querySelectorAll('[data-form]');
      const tabsWrapper = this.querySelector('[data-login-tabs]');

      const showForm = (targetFormId) => {
        forms.forEach(form => {
          form.classList.add('hidden');
          form.classList.remove('flex');
        });

        const targetForm = this.querySelector(`[data-form="${targetFormId}"]`);
        if (targetForm) {
          targetForm.classList.remove('hidden');
          targetForm.classList.add('flex');
        }

        if (targetFormId === 'forgot-pass') {
          tabsWrapper.classList.add('hidden');
        } else {
          tabsWrapper.classList.remove('hidden');
        }

        tabs.forEach(tab => {
          tab.parentElement.classList.remove('active');
        });
        const activeTab = this.querySelector(`[data-target="${targetFormId}"]`);
        if (activeTab) {
          activeTab.parentElement.classList.add('active');
        }
      };

      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const targetFormId = this.getAttribute('data-target');
          showForm(targetFormId);
        });
      });

      if (window.location.hash === '#forgot') {
        showForm('forgot-pass');
      }
      window.addEventListener('login:showForm', function (e) {
        showForm(e.detail);
      });
    }
  }
  customElements.define('account-login', AccountLogin);
}